import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { api, unwrap } from '@/api/client';
import { qk } from '@/api/queries';
import { rememberLocale, type Locale } from '@/i18n';

/** The header RU / UZ switch: applies at once, then persists to users.locale (PATCH /admin/auth/me). */
export function useLocaleSwitch(): { locale: Locale; setLocale: (l: Locale) => void } {
  const { i18n } = useTranslation();
  const qc = useQueryClient();
  const save = useMutation({
    mutationFn: (locale: Locale) => unwrap(api.PATCH('/admin/auth/me', { body: { locale } })),
    onSuccess: (me) => qc.setQueryData(qk.me, me),
  });
  const locale: Locale = i18n.language === 'uz' ? 'uz' : 'ru';
  return {
    locale,
    setLocale: (l) => {
      rememberLocale(l);
      void i18n.changeLanguage(l);
      save.mutate(l);
    },
  };
}
